import firebase from "firebase";
import Firestore = firebase.firestore.Firestore;

export interface Doc {
  content: string;
}

export function newDoc(): Doc {
  return {
    content: ""
  };
}

export class DocService {
  private firestore: Firestore;

  constructor() {
    this.firestore = firebase.firestore();
  }

  async getDoc(repoId: string, id: string): Promise<Doc> {
    const repoSnapshot = await this.firestore
      .doc(`repos/${repoId}/docs/${id}`)
      .get();
    return repoSnapshot.data() as Doc;
  }
}
